import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AnimatedButton = ({ text = "More Services" }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link to="/residential-roofing" className="text-decoration-none" style={{ display: 'inline-block' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        
        {/* ANIMATION 1: Pulsing Red Aura */}
        <motion.div
          animate={{
            opacity: [0.2, 0.5, 0.2],
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          style={{
            position: 'absolute',
            inset: '-4px', // আভাটা একটু কমিয়ে আনা হয়েছে
            borderRadius: '50px',
            background: '#b22335',
            filter: 'blur(12px)',
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />

        {/* The Main Button RoofingSection/ */}
        <motion.button
          className="btn position-relative overflow-hidden"
          style={{
            // ইমেজের মতো কালার এবং প্যাডিং সেট করা হয়েছে
            background: isHovered ? '#3D3B6D' : '#b22335', 
            color: '#ffffff',
            border: 'none',
            borderRadius: '50px', // পুরোপুরি রাউন্ড শেপ (ইমেজের মতো)
            padding: '10px 30px', // উইডথ কন্ট্রোল করার জন্য প্যাডিং কমানো হয়েছে
            fontSize: '1.1rem',
            fontWeight: '500',
            zIndex: 1,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            
            boxShadow:isHovered ? '0 6px 50px #3D3B6D' : '0 4px 15px rgba(0,0,0,0.2)', 
            transition: 'background 0.3s ease',
          }}
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
          whileHover={{
            scale: 1.03,
            y: -2,
          }}
          whileTap={{ scale: 0.97 }}
        >
          
          {/* Shimmer Effect */}
          <motion.span
            className="position-absolute"
            style={{
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
              zIndex: 2,
            }}
            animate={{
              left: isHovered ? '100%' : '-100%',
            }}
            transition={{ duration: 0.6 }}
          />

          {/* Button Content */}
          <span className="position-relative d-flex align-items-center gap-2" style={{ zIndex: 3 }}>
            {text}
            <motion.span
              animate={{ x: isHovered ? 4 : 0 }}
              style={{ display: 'inline-flex' }}
            >
              →
            </motion.span>
          </span>
        </motion.button>
      </div>
    </Link>
  );
};

export default AnimatedButton;